"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const l = (o) => /* @__PURE__ */ c(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.182 15.207c-.474 1.465-2.291 6.18-5.8 5.47a4.5 4.5 0 0 1-1.121-.427.62.62 0 0 0-.612.018 3.6 3.6 0 0 1-1.082.407c-3.496.723-5.326-4.005-5.807-5.47-.805-2.463-.657-4.644.404-5.985.756-.954 1.9-1.394 3.334-1.274.979.072 2.472.382 3.313.82q.013.004.024.005.115.058.25.063l.016.002.039-.001a.6.6 0 0 0 .242-.067c.81-.414 2.114-.767 3.106-.841 1.425-.116 2.578.333 3.33 1.296 1.054 1.346 1.187 3.525.364 5.984m-5.973-10.95c.35-.517.957-.813 1.366-.962.026.675-.098 1.22-.368 1.619-.351.52-.957.814-1.365.963-.025-.676.098-1.22.367-1.62m6.594 4.195c-1.008-1.288-2.571-1.93-4.412-1.771-.86.064-1.886.307-2.754.628l-.02-.142c.03.003.057.013.086.013q.19 0 .38-.065c.67-.216 1.585-.651 2.16-1.502.45-.666.642-1.528.57-2.553a1.12 1.12 0 0 0-.464-.858 1.16 1.16 0 0 0-1.01-.148c-.67.215-1.59.652-2.165 1.504a3.2 3.2 0 0 0-.383.83c-.496-.957-1.201-1.65-2.163-1.774a.636.636 0 0 0-.7.54.625.625 0 0 0 .54.7c.994.128 1.63 1.706 1.89 3.39A12.7 12.7 0 0 0 8.597 6.7c-1.83-.155-3.398.463-4.411 1.743-1.327 1.676-1.551 4.283-.612 7.15 1.5 4.576 4.197 6.938 7.253 6.304a5 5 0 0 0 1.158-.39c.39.182.765.31 1.139.392q.49.1.966.1c2.658 0 4.96-2.317 6.28-6.401.958-2.858.75-5.462-.566-7.146",
        clipRule: "evenodd"
      }
    )
  }
), i = e(l);
export {
  i as Grocery,
  i as default
};
